import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "InfoGray",
  "use": "InfoGray-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"InfoGray\">\n<path d=\"M7.99992 1.33325C4.31992 1.33325 1.33325 4.31992 1.33325 7.99992C1.33325 11.6799 4.31992 14.6666 7.99992 14.6666C11.6799 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.6799 1.33325 7.99992 1.33325ZM8.66659 11.3333H7.33325V7.33325H8.66659V11.3333ZM8.66659 5.99992H7.33325V4.66659H8.66659V5.99992Z\" fill=\"#848484\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol